import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_COMPLAINT_QUESTION,
  ARRANGE_COMPLAINT_QUES_ORDER,
  DELETE_COMPLAINT_QUESTION,
  EDIT_COMPLAINT_QUESTION,
  GET_ADDED_COMPLAINT_QUESTION,
  GET_COMPLAINT_REGISTER,
  GET_EMPLOYEE_SUBMITED_FORM,
  GET_COMPLAINT_FORM_PREVIEW,
  REVIEW_COMPAINT_FORM,
  GET_COMPLAINT_FORM,
} from "./actionTypes";
import {
  AddComplaintFormQuestion,
  DeleteComplaintQuestion,
  EditComplaintQuestion,
  GetAddedQuestion,
  onGettingComplaintPreview,
  onGettingComplaintList,
  updateComplaintQuesOrder,
  onGettingComplaintDetail,
  onReviewingComplaintForm,
} from "helpers/fakebackend_helper";
import { responseHandler } from "common/CommanFunction";
import {
  addComplaintQuestionError,
  addComplaintQuestionSuccess,
  deleteQuestionError,
  deleteQuestionSuccess,
  editComplaintQuestionError,
  editComplaintQuestionSuccess,
  getComplaintFormDetailError,
  getComplaintFormDetailSuccess,
  getComplaintQuestionError,
  getComplaintQuestionSuccess,
  getComplaintRegisterError,
  getComplaintRegisterSuccess,
  getComplaintPreviewError,
  getComplaintPreviewSuccess,
  submitComplaintFormReview,
  submitComplaintFormReviewError,
  submitComplaintFormReviewSuccess,
  reaarangeComplaintQuestionError,
  reaarangeComplaintQuestionSuccess,
} from "./actions";
import showToast from "common/Notification";

const toastTitle = "Feedback Report";
function* onAddQuestion({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(AddComplaintFormQuestion, data);
    yield call(responseHandler, toastTitle, response, addComplaintQuestionSuccess, addComplaintQuestionError, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addComplaintQuestionError(error));
    showToast("error", toastTitle, error);
  }
}

function* getAddedQuestion({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(GetAddedQuestion, data);
    yield call(responseHandler, toastTitle, response, getComplaintQuestionSuccess, getComplaintQuestionError, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getComplaintQuestionError(error));
    showToast("error", toastTitle, error);
  }
}

function* deleteQuestion({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(DeleteComplaintQuestion, data);
    yield call(responseHandler, toastTitle, response, deleteQuestionSuccess, deleteQuestionError, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteQuestionError(error));
    showToast("error", toastTitle, error);
  }
}

function* editComplaintQuestion({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(EditComplaintQuestion, data);
    yield call(responseHandler, toastTitle, response, editComplaintQuestionSuccess, editComplaintQuestionError, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(editComplaintQuestionError(error));
    showToast("error", toastTitle, error);
  }
}

function* rearrangeComplaintQuestion({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(updateComplaintQuesOrder, data);
    yield call(responseHandler, toastTitle, response, reaarangeComplaintQuestionSuccess, reaarangeComplaintQuestionError, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(reaarangeComplaintQuestionError(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetComplaints({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingComplaintList, data);
    yield call(responseHandler, toastTitle, response, getComplaintRegisterSuccess, getComplaintRegisterError, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(getComplaintRegisterError(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetComplaintFormDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingComplaintDetail, data);
    yield call(responseHandler, toastTitle, response, getComplaintFormDetailSuccess, getComplaintFormDetailError, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(getComplaintFormDetailError(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetComplaintPreview({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingComplaintPreview, data);
    yield call(responseHandler, toastTitle, response, getComplaintPreviewSuccess, getComplaintPreviewError, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(getComplaintPreviewError(error));
    showToast("error", toastTitle, error);
  }
}

function* onReviewComplaintForm({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onReviewingComplaintForm, data);
    yield call(responseHandler, toastTitle, response, submitComplaintFormReviewSuccess, submitComplaintFormReviewError, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(submitComplaintFormReviewError(error));
    showToast("error", toastTitle, error);
  }
}
function* ComplaintRegisterSaga() {
  yield takeEvery(ADD_COMPLAINT_QUESTION, onAddQuestion);
  yield takeEvery(GET_ADDED_COMPLAINT_QUESTION, getAddedQuestion);
  yield takeEvery(DELETE_COMPLAINT_QUESTION, deleteQuestion);
  yield takeEvery(EDIT_COMPLAINT_QUESTION, editComplaintQuestion);
  yield takeEvery(ARRANGE_COMPLAINT_QUES_ORDER, rearrangeComplaintQuestion);
  yield takeEvery(GET_COMPLAINT_REGISTER, onGetComplaints);
  yield takeEvery(GET_COMPLAINT_FORM, onGetComplaintFormDetail);
  yield takeEvery(GET_COMPLAINT_FORM_PREVIEW, onGetComplaintPreview);
  yield takeEvery(REVIEW_COMPAINT_FORM, onReviewComplaintForm);
}
export default ComplaintRegisterSaga;
